import { createSlice } from '@reduxjs/toolkit';
import { onInitial, onSetLoaded, onSetError, } from '../utils/loadedError';

const initialstatuswellboresState = {
  isLoaded: false,
  Error: null,
  data: []
};

const statuswellboresSlice = createSlice({
  name: 'statuswellbores',
  initialState: initialstatuswellboresState,
  reducers: {
    onInitial,
    onSetLoaded,
    onSetError,
    onClearStore(state) {
      state = initialstatuswellboresState;
    },
  },
});

export const statuswellboresActions = statuswellboresSlice.actions;
export default statuswellboresSlice.reducer;